import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsEditPermissionSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-edit-permissions-schemes',
	path: '/jira/settings/issues/permission-schemes/:schemeId',
};
